import type { FabricObject } from 'fabric';

const MAX_RENDER_SCALE = 4;

export function resolveMnemonicEChartsRenderScale(fabricObject: FabricObject): number {
    const zoom = fabricObject.canvas?.getZoom() ?? 1;
    const scaleX = Math.abs(fabricObject.scaleX ?? 1);
    const scaleY = Math.abs(fabricObject.scaleY ?? 1);
    const dpr = typeof window !== 'undefined' ? window.devicePixelRatio || 1 : 1;

    return Math.min(MAX_RENDER_SCALE, Math.max(2, Math.ceil(zoom * Math.max(scaleX, scaleY) * dpr)));
}

export function resolveMnemonicEChartsSize(fabricObject: FabricObject): { width: number; height: number } {
    return {
        width: Math.max(1, Math.round(fabricObject.width ?? 1)),
        height: Math.max(1, Math.round(fabricObject.height ?? 1)),
    };
}

export function createOffscreenEChartsContainer(width: number, height: number): HTMLDivElement {
    const container = document.createElement('div');
    container.style.position = 'fixed';
    container.style.left = '-10000px';
    container.style.top = '-10000px';
    container.style.width = `${width}px`;
    container.style.height = `${height}px`;
    container.style.pointerEvents = 'none';
    document.body.appendChild(container);
    return container;
}

export function drawEChartsCanvas(
    ctx: CanvasRenderingContext2D,
    sourceCanvas: HTMLCanvasElement,
    x: number,
    y: number,
    width: number,
    height: number,
): void {
    const prevSmoothing = ctx.imageSmoothingEnabled;
    const prevQuality = ctx.imageSmoothingQuality;

    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(sourceCanvas, x, y, width, height);
    ctx.imageSmoothingEnabled = prevSmoothing;
    ctx.imageSmoothingQuality = prevQuality;
}
